// @ts-nocheck
/* eslint-disable spire/export-styles */
import { createWidgetElement } from "@insite/client-framework/Components/ContentItemStore";
import { PageLinkModel } from "@insite/client-framework/Services/ContentService";
import constants from "@store/constants";
import React from "react";

interface OwnProps {
    title: string;
    certificateId: string;
    returnPage?: PageLinkModel;
}

type Props = OwnProps;

const TECContactSupportPageTypeLink: React.FunctionComponent<Props> = ({ title, certificateId, returnPage }) => {
    const queryStringToPass = returnPage
        ? `certificateId=${certificateId}&returnPage=${returnPage?.type}`
        : `certificateId=${certificateId}`;

    return createWidgetElement("Basic/PageTypeLink", {
        fields: {
            pageType: constants.pageType.tecContactSupport,
            overrideTitle: title,
            queryString: queryStringToPass,
        },
    });
};

export default TECContactSupportPageTypeLink;
